import React, { createRef } from 'react';
import './styles/search_tourist_form.scss'; // стили для компонента
import ProgressBar from '@ramonak/react-progress-bar';

import DepartCity from './components/DepartCity';
import DestinationCountry from './components/DestinationCountry';
import Dates from './components/Dates';
import Nights from './components/Nights';
import Peoples from './components/Peoples';
import Stars from './components/Stars';
import Meals from './components/Meals';
import Regions from './components/Regions';
import Services from './components/Services';
import Hotels from './components/Hotels';
import Price from './components/Price';
import SearchTourButton from './components/SearchTourButton';
import Races from './components/Races';
import SearchTourMoreButton from './components/SearchTourMoreButton';
import { FactBanner, FeatureBanner, Banner, InfoBanner } from './views/Banners';
import { FaStar, FaHotel } from 'react-icons/fa';

import OneTouristHotel from './components/OneTouristHotel';
import OneHotTourView from './views/OneHotTourView';
import OneHotTourMobileView from './views/OneHotTourMobileView';
import HotelInfoView from './views/HotelInfoView';
import CartBar from './views/CartBar';
import LinksBar from './views/LinksBar';

import requestModel from '../../entities/requestModel';
import tourvisorAPI from '../api/tourvisorAPI';
import cabinetAPI from '../api/cabinetAPI';
import TourFetcher from './utils/TourFetcher';
import TourRequest from './utils/TourRequest';

import DEPART_CITY_DIC from './constants/DepartCity';
import COUNTRY_DIC from './constants/DestinationCountry';

import {
  TOUR_SEARCH_INTERVAL,
  TOUR_SEARCH_TIMES_LIMIT,
  COUNTRY_RANK_DIC,
  COUNTRY_LIST,
  HOTELS_LIMIT,
  REQUEST_KEYS_MAP,
  TOURS_LIST_EMPTY,
  DATES_LIST,
  DATE_FROM_OFFSET,
  DATE_TO_OFFSET,
} from '../../shared/config';
import prepareGetParamsToRedirect from './utils/prepareGetParamsToRedirect';

import moment from 'moment';
import { AiOutlineApi, AiOutlineInfoCircle } from 'react-icons/ai';
import SearchNotification from '../../shared/components/SearchNotification';
import geograftourAPI from '../api/geograftourAPI';
import { PiAirplaneTakeoffLight } from 'react-icons/pi';
import { MdOutlineYoutubeSearchedFor } from 'react-icons/md';
import {
  REQUEST_FIELD_LIST,
  REQUEST_FIELD_TO_URL_MAP,
} from './constants/RequestFieldList';

const tour_search_counter = {};

let isLoadForm = false;
let TOURS_LIST = TOURS_LIST_EMPTY;

function hasQueryStringParameters() {
  return window.location.search.length > 0;
}

class SearchTouristForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleContinue = this.handleContinue.bind(this);
    this.onCartUpdate = this.onCartUpdate.bind(this);

    this.setDepart = this.setDepart.bind(this);
    this.setCountry = this.setCountry.bind(this);
    this.setMeal = this.setMeal.bind(this);
    this.setOperators = this.setOperators.bind(this);
    this.setRegions = this.setRegions.bind(this);
    this.setSubRegions = this.setSubRegions.bind(this);
    this.setServices = this.setServices.bind(this);
    this.setActypes = this.setActypes.bind(this);
    this.setHotels = this.setHotels.bind(this);
    this.resetHotels = this.resetHotels.bind(this);
    this.setStars = this.setStars.bind(this);
    this.setRating = this.setRating.bind(this);
    this.setRaces = this.setRaces.bind(this);
    this.setPromo = this.setPromo.bind(this);
    this.setDates = this.setDates.bind(this);
    this.setNights = this.setNights.bind(this);
    this.setPrice = this.setPrice.bind(this);
    this.setPeoples = this.setPeoples.bind(this);
    this.setFastBooking = this.setFastBooking.bind(this);
    this.setRecomendHotels = this.setRecomendHotels.bind(this);
    this.handleHasReviews = this.handleHasReviews.bind(this);
    this.setReviewedHotels = this.setReviewedHotels.bind(this);
    this.setHotelsIdWithReviews = this.setHotelsIdWithReviews.bind(this);
    this.handleRecomend = this.handleRecomend.bind(this);
    // this.needBanner = this.needBanner.bind(this);
    // this.needFact = this.needFact.bind(this);
    this.needInfo = this.needInfo.bind(this);
    this.needFeature = this.needFeature.bind(this);
    this.handleAutosearch = this.handleAutosearch.bind(this);
    this._handleFlightTypeChange = this._handleFlightTypeChange.bind(this);

    this.handleSortOnPrice = this.handleSortOnPrice.bind(this);
    this.handleShowHotelsAll = this.handleShowHotelsAll.bind(this);
    this.setDiscount = this.setDiscount.bind(this);

    this.toggleHotelPopup = this.toggleHotelPopup.bind(this);
    this.getHotelInfo = this.getHotelInfo.bind(this);
    this.setHotelData = this.setHotelData.bind(this);
    this.handleSearchError = this.handleSearchError.bind(this);
    this.restartSearchWithNewRequest =
      this.restartSearchWithNewRequest.bind(this);
    this.controllerRef = createRef();
    this.checkTourRequestTimeoutRef = createRef();

    this.fetchTours = this.fetchTours.bind(this);

    this.toursRef = React.createRef();

    this.state = {
      autosearch: false,
      request: this.getPrepareParams(requestModel),
      flightTypeChange: false,
      response: {
        data: {
          result: {
            hotel: [],
          },
          status: {
            hotelsfound: 0,
            maxprice: 0,
            minprice: 0,
            operators: [],
            progress: 0,
            requestid: 0,
            state: '',
            toursfound: 0,
          },
        },
      },
      searchErrorText: '',
      searchError: false,
      request_id: null,
      tour_request: null,
      requestedDeparture: null,
      is_mobile: false,
      recomend_hotels: [],
      startSearch: false,
      isSearching: false,
      wasSearching: false,
      multi: false,
      type: 'search',
      items: [],
      results: [],
      requests: {},
      touroperators_excluded: [],
      discount: [],
      items_total: 0,
      fact: '',
      cart: {
        user: null,
        likes: 0,
        cart: 0,
        seen: 0,
      },
      likes: [],
      carts: [],
      showAll: false,
      isHotelPopupOpened: false,
      hotelDetails: {},
      isHotelInfoLoading: false,
      hotelId: '',
      hotelData: '',
      hotelsIdWithReviews: [],
      hotelsInfoWithReviews: [],
      hotelPopupTabNumber: 0,
      hasReviews: false,
    };
  }

  _processTourResponse(request, response) {
    console.log('process tour response');
  }

  _mapHotRequestParams(params) {
    let date_from = moment().add('day', DATE_FROM_OFFSET).format('DD.MM.YYYY');
    let date_to = moment().add('day', DATE_TO_OFFSET).format('DD.MM.YYYY');

    return {
      city: params.departId
        ? params.departId
        : params.cityFromId
        ? params.cityFromId
        : 1,
      countries: params.countryId,
      datefrom: params.s_departFrom ? params.s_departFrom : date_from,
      dateto: params.s_departTo ? params.s_departTo : date_to,
      items: params.pageSize,
    };
  }

  handleShowHotelsAll() {
    this.setState({
      showAll: true,
    });
  }

  setCart(cart) {
    this.setState({
      cart: cart,
    });
  }

  async getCart() {
    await this.getLikes();
    await this.getCarts();
    const cart = await cabinetAPI.getCart();
    this.setCart(cart);
  }

  setCarts(carts) {
    this.setState({
      carts: carts,
    });
  }

  setLikes(likes) {
    this.setState({
      likes: likes,
    });

    /** для пометки залайканых туров необходим список лайкнутых
     *
     *   к моменту выгрузки - список лайкнутых должен уже получен в стейт
     *
     *   проверка залогинен ли пользователь
     *   1.Форма showLogin()
     *   если залогинен - проставляем лайк
     *   иначе - лайк не ставится пока пользователь не будет авторизован
     *   c добавлением в корзине - аналогичная логика
     *
     *   при клике на карточке тура в выгрузке - событие добавить в просмотренные
     *   даже если пользователь не авторизован добавляем в просмотренные используя механизм сессии
     *   просмотренные туры нельзя удалять, и не дублировать если несколько раз просмотрен тур
     *   проверить все параметры tour_data для найденых туров search и hot туров
     *   при добавлении тура в ЛК через просмотр лайк или в корзину, тур получает персональный geokey и tour_hash
     *   посмотреть проверку tour_hash чтобы данные нельзя было подделать
     *   возможно что при изменении цены tour_hash станет не валидным - реализуем update либо рассмотреть формирование
     *   через статичные данные на тур.
     *
     *   список лайкнутых сверяем с tour_id в каждом туре при выгрузке для найденых отелей/ туров / горящих
     *   если тур был залайкан необходимо сохранить в состояние параметр geokey для обработки события - удаления лайка
     *   аналогично должно срабатывать действие по удалению из корзины
     *   настроить интересную анимацию при добавлении лайка/ в корзину для визуализации UI/UX
     *   */
  }

  async getLikes() {
    const likes = await cabinetAPI.getLikes();
    if (likes && likes.length) {
      this.setLikes(likes);
    }
  }

  async getCarts() {
    const carts = await cabinetAPI.getCarts();
    if (carts && carts.length) {
      this.setCarts(carts);
    }
  }

  onCartUpdate() {
    this.getCart();
  }

  needFeature(num) {
    return !(parseInt(num) % 10) && num > 0;
  }

  needInfo(num) {
    return num % 10 && !(num % 5) && !((num + 5) % 20);
  }

  /**
   * Получить туры по параметрам запроса
   *
   * @param {Object} requestParams
   *
   *
   */
  async _sendRequest(requestParams, options) {
    console.warn('send request');
    if (options.method === 'hot') {
      let requestQuery = new URLSearchParams(
        this._mapHotRequestParams(requestParams)
      ).toString();
      // поиск горящих туров
      const res = await tourvisorAPI.hot(requestQuery);
      console.warn('response hot:', res);
      if (res.hottours && res.hottours.tour) {
        for (const tour of res.hottours.tour) {
          TOURS_LIST.push(tour);
        }
        this.setState(
          {
            items: [...TOURS_LIST],
          },
          () => {
            this.handleSortOnPrice();
          }
        );
      }
    } else if (options.method === 'search') {
      // поиск отелей с ценами

      const tourRequest = {};
      let requestExtendKeysList = Object.keys(requestParams);
      requestExtendKeysList.forEach((key) => {
        // фиксим request в каждой итерации
        console.warn(REQUEST_KEYS_MAP[key]);
        tourRequest[REQUEST_KEYS_MAP[key]] = requestParams[key];
      });
      if (this.props.GLOBAL.TOUROPERATOR) {
        // для страниц поиска по конкретному туроператору
        tourRequest.operators = [this.props.GLOBAL.TOUROPERATOR.id];
      }

      // фиксим формат дат
      if (tourRequest.datefrom) {
        tourRequest.datefrom = tourRequest.datefrom.split('/').join('.');
      }
      if (tourRequest.dateto) {
        tourRequest.dateto = tourRequest.dateto.split('/').join('.');
      }

      let requestQuery = prepareGetParamsToRedirect(tourRequest);
      console.warn(requestQuery, this.props.GLOBAL.TOUROPERATOR);
      const res = await tourvisorAPI.search(requestQuery);
      // в res ожидаем request_id или данные из кэша
      if (res && res.error) {
        alert(res.error.errormessage);
      }
      if (res && res.data) {
        console.error('КЭШ');
        console.log(res.data);

        if (res.data && res.data.result && res.data.result.hotel) {
          for (const hotel of res.data.result.hotel) {
            TOURS_LIST.push(hotel);
          }
          this.setState({
            results: [...TOURS_LIST],
          });
          return;
        }

        this.setState({ response: res });
      } else if (res && res.result && res.result.requestid) {
        console.error('SERVER');
        const { requestid } = res.result;
        console.log('response search:', requestid);

        const result = await this.fetchToursAndResult(requestid);
        console.error(result);

        return;
      } else {
        alert('Ошибка получения данных от провайдера');
      }
    }

    // в случае поиска по горящим отображение результата происходит по успешному завершению
    // всех запросов, а хотелось бы иметь возможность контролировать
    // и выводить на каждом этапе получения ответа найденных туров
  }

  async fetchToursAndResult(requestId) {
    console.warn(requestId);
    let progress = 0;
    let onpage = 1;

    while (progress < 100) {
      try {
        this.controllerRef = new AbortController();
        const signal = this.controllerRef.signal;

        const response = await tourvisorAPI.result(
          requestId,
          onpage,
          0,
          signal
        );
        console.warn('result json:', response);
        if (response.data.status.progress) {
          progress = response.data.status.progress;
          console.log(`${progress} %`);
        }
        return requestId;
      } catch (err) {
        console.error('Ошибка при выполнении запроса:', err);
        break; // Прервать выполнение в случае ошибки
      }
    }
    return [];
  }

  /**
   * Получить туры по списку запросов
   *
   * @param {requestHotParams[] | requestTourParams[] } requestParams
   *
   *
   */
  async _sendAllRequests(allRequestsParams, options) {
    for (const request of allRequestsParams) {
      await this._sendRequest(request, options);
    }
    // по завершению поиска
    this.setState({
      items: [...this._removeDuplicates(TOURS_LIST)],
    });
  }

  handleSortOnPrice() {
    const tours = [...this.state.items];

    tours.sort((a, b) => +a.price - +b.price);
    this.setState({
      items: this._removeDuplicates(tours),
    });
  }

  handleSortPrice(hotels) {
    const tours = [...hotels];

    if (tours.length) {
      tours.sort((a, b) => +a.price - +b.price);

      this.setState({
        results: tours,
      });
    }
  }

  /**
   * Удалить дубликаты туров из списка
   *
   * @param {Object[]} arr
   */
  _removeDuplicates(arr) {
    const uniqueSet = new Set(arr.map((obj) => JSON.stringify(obj)));
    return Array.from(uniqueSet).map((str) => JSON.parse(str));
  }

  fetchTours(method = 'hot') {
    TOURS_LIST = []; // перед началом поиска ощищаем контейнер выгрузки туров
    this._sendAllRequests(this.props.GLOBAL.TOURS_REQUEST.request, {
      provider: 'tourvisor',
      method: method,
    });
    // подготовить запрос request, searchType
    // провайдер. важно заложить в адаптацию выбор провайдера,
    // иначе при переходе на другого провайдера, получение туров
    // с другими параметрами будет - огромная боль
    // от типа запроса будут отличаться параметры запроса и url для запроса

    // неважно как реализован api провайдера, мы должны иметь возможность
    // выгружать списки по различным параметрам в выгрузку туров

    // структура туров должна быть унифицирована базовым абстрактным классом BaseTour
    // с общими параметрами.
    // и наследуемыми расширениями класса HotTour и SearchTour

    // в зависимости от

    // могут выгружаться не только найденые туры но и отели,
    // которые могут иметь вложенные (цены ) на туры

    // в подготовке параметров запроса
    // должно быть предусмотрен приоритет параметров поиска url, админка, форма поиска
    //
    // логика на продолжение поиска, и условие на автоматическое продолжение поиска или по требованию( города на замену, город по умолчанию, чартерные рейсы, все рейсы)
  }

  /**
   * Проверка найденых туров в отели из кэша
   */
  async _checkTourRequest(request) {
    this.controllerRef = new AbortController();
    const signal = this.controllerRef.signal;
    var request_id = request.requestid || this.response.data.status.requestid,
      tour_count = request.tour_count;
    delete request.tour_count;

    const response = await tourvisorAPI.result(
      request_id,
      request.onpage,
      0,
      signal
    );
    const progressPrev = this.state.response.data.status.progress;
    this.setState({ response, progressPrev });
    let search_status = (response.data && response.data.status) || {},
      result = response;
    if (
      search_status.state === 'finished' ||
      result.length >= tour_count ||
      tour_search_counter[request_id] > TOUR_SEARCH_TIMES_LIMIT
    ) {
      this.setState({ isSearching: false });
      // Туров достаточно или превышен лимит по количеству запросов => возвращаем полученный результат
      if (!search_status.toursfound && this.state.request.hideregular) {
        this.setState(
          {
            request: {
              ...this.state.request,
              hideregular: 0,
            },
          },
          () => this.handleSearch()
        );
        this._handleFlightTypeChange();
      }
      if (result.length > tour_count) {
        result = result.slice(0, tour_count);
      }
    } else if (search_status.state == 'no search results') {
      console.log(result);
    } else {
      // Посылаем повторный запрос через TOUR_SEARCH_INTERVAL мс
      tour_search_counter[request_id] += 1;
      this.checkTourRequestTimeoutRef = setTimeout(() => {
        this._checkTourRequest(request);
      }, TOUR_SEARCH_INTERVAL);
    }
  }

  _handleFlightTypeChange() {
    this.setState({ flightTypeChange: true });
    setTimeout(() => {
      this.setState({ flightTypeChange: false });
    }, 5000);
  }

  _parseSearchResponse(request, response) {
    const request_id = response && response.result && response.result.requestid;

    if (!request_id) {
      this.setState({
        startSearch: false,
        request,
        response,
        isSearching: false,
      });
      /* Не найден request_id в ответе, пытаемся сразу выдать туры */
      this._processTourResponse(request, response);
      return;
    }

    const tour_request = { tour_count: request.tour_count || request.onpage };

    if (request.departure) {
      tour_request.departure = request.departure;
    }
    if (request.onpage) {
      tour_request.onpage = request.onpage;
    }
    if (request.priceonly) {
      tour_request.priceonly = request.priceonly;
    }
    tour_request.requestid = request_id;
    tour_search_counter[request_id] = 0;
    this.setState({
      tour_request,
      request_id,
      startSearch: false,
      wasSearching: true,
    });

    this.checkTourRequestTimeoutRef = setTimeout(() => {
      this._checkTourRequest(tour_request);
    }, TOUR_SEARCH_INTERVAL);
  }

  async handleSearch(auto = false) {
    this.setState({
      requestedDeparture: this.state.request.departure,
      results: [],
      items: [],
      showAll: false,
      response: { data: { status: { progress: 5 } } },
      searchError: false,
      searchErrorText: '',
      isSearching: true,
    });
    const { request } = this.state; // формируем запрос на основе параметров формы
    if (request.ages.length) {
      request.ages.map((age, idx) => {
        request[`childage${idx + 1}`] = age;
      });
    }

    if (!!request.mealbetter) {
      request.mealbetter = 1; // fix param mealbetter
    }

    if (request.subregions.length) {
      request.regions = [];
    }
    if (request.hotels.includes(2)) {
      let index = request.hotels.indexOf(2);
      if (index !== -1) {
        request.hotels.splice(index, 1);
      }
    }
    if (request.actypes) {
      const correctActypes = request.actypes.map((actype) => {
        return actype.replace(9, '');
      });
      request.actypes = correctActypes;
    }

    TOURS_LIST = []; //  общий контейнер сброс, чтобы потом поместить результат по отелям в общий список
    let requestQuery = new URLSearchParams(request).toString();
    const res = await tourvisorAPI.search(requestQuery);
    if (!res.error) {
      this._parseSearchResponse(request, res);
    } else {
      this.handleSearchError(res);
    }
  }

  handleSearchError(res) {
    const { error, errormessage } = res;
    this.setState({
      response: { data: { status: { progress: 100, status: 'finished' } } },
      searchErrorText: errormessage || "Наблюдаются проблемы в работе поиска, попробуйте еще раз позднее",
      searchError: error,
      startSearch: false,
      isSearching: false,
    });
  }

  handleRecomend(recomendList) {
    this.setState({ recomend_hotels: recomendList });
  }

  handleHasReviews(hasReviews) {
    this.setState({ hasReviews });
  }

  async handleContinue() {
    console.log('handle continue');
    const rid =
      this.state.request_id || this.state.response.data.status.requestid;
    const res = await tourvisorAPI.continue(rid);
    if (this.state.tour_request) {
      this._checkTourRequest(this.state.tour_request);
    } else {
      this._checkTourRequest({ ...this.state.request, requestid: rid });
    }
  }

  setDepart(value) {
    let currency = 0;
    if (DEPART_CITY_DIC[value].country_id == 78) {
      currency = 3;
    }
    this.setState({
      request: {
        ...this.state.request,
        departure: value,
        currency: currency,
      },
      departure: value,
    });
  }

  setMeal(value) {
    this.setState({
      request: {
        ...this.state.request,
        meal: value,
      },
    });
  }

  setCountry(value) {
    this.setState({
      request: {
        ...this.state.request,
        country: value,
        regions: [],
        subregions: [],
        hotels: [],
      },
    });
  }

  getQueryParams() {
    const { request } = this.state;

    const filteredObj = REQUEST_FIELD_LIST.reduce((acc, field) => {
      if (request.hasOwnProperty(field)) {
        if (typeof REQUEST_FIELD_TO_URL_MAP[field] !== 'undefined') {
          acc[REQUEST_FIELD_TO_URL_MAP[field]] = request[field];
        } else {
          acc[field] = request[field];
        }
      }
      return acc;
    }, {});

    filteredObj.starsbetter = 1;
    filteredObj.mealbetter = 0;

    const queryParams = prepareGetParamsToRedirect(filteredObj);

    return [
      'tours',
      COUNTRY_DIC[request.country].url,
      DEPART_CITY_DIC[request.departure].url,
      `${queryParams}`,
    ].join('/');
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.PAGE === 'tours') {
      if (prevState.request.country !== this.state.request.country) {
        const params = this.getQueryParams();
        setTimeout(() => {
          window.location.href = `/${params}`;
        }, 1000);
      }
    }
  }

  setOperators(value) {
    this.setState({
      request: {
        ...this.state.request,
        operators: value,
      },
    });
  }

  setRegions(value) {
    this.setState({
      request: {
        ...this.state.request,
        regions: value,
      },
    });
  }

  setSubRegions(value) {
    this.setState({
      request: {
        ...this.state.request,
        subregions: value,
      },
    });
  }

  setServices(value) {
    this.setState({
      request: {
        ...this.state.request,
        services: value,
      },
    });
  }

  setActypes(value) {
    this.setState({
      request: {
        ...this.state.request,
        actypes: value,
      },
    });
  }

  setPromo(value) {
    this.setState({
      request: {
        ...this.state.request,
        promo: value,
      },
    });
  }

  setRating(value) {
    this.setState({
      request: {
        ...this.state.request,
        rating: value,
      },
    });
  }

  setStars(value) {
    this.setState({
      request: {
        ...this.state.request,
        stars: value,
      },
    });
  }

  setRaces(value) {
    this.setState({
      request: {
        ...this.state.request,
        hideregular: value,
      },
    });
  }

  setHotels(value) {
    this.setState({
      request: {
        ...this.state.request,
        hotels: value,
      },
    });
  }

  resetHotels() {
    this.setState((prevState) => ({
      request: {
        ...prevState.request,
        hotels: [],
      },
    }));
  }

  setPrice({ priceto, pricefrom, currency }) {
    this.setState({
      request: {
        ...this.state.request,
        priceto: priceto,
        pricefrom: pricefrom,
        currency: currency,
      },
    });
  }

  setDates(dates) {
    this.setState({
      request: {
        ...this.state.request,
        dateto: dates.dateto,
        datefrom: dates.datefrom,
      },
    });
  }

  setNights(from, to) {
    this.setState({
      request: {
        ...this.state.request,
        nightsfrom: from,
        nightsto: to,
      },
    });
  }

  setPeoples(params) {
    this.setState({
      request: {
        ...this.state.request,
        adults: params.adults,
        child: params.kids,
        ages: params.ages,
      },
    });
  }

  setFastBooking(isCheck) {
    if (isCheck) {
      this.setState({
        request: {
          ...this.state.request,
          services: [...this.state.request.services, 46],
        },
      });
    }
  }

  setRecomendHotels(recomend) {
    this.setState({
      request: {
        ...this.state.request,
        recomend,
      },
    });
  }

  setReviewedHotels(hasReviews) {
    this.setState({
      request: {
        ...this.state.request,
        hasReviews,
      },
    });
  }

  getPrepareParams(store = {}) {
    const queryString = window.location.search;
    // Создаем объект URLSearchParams на основе query string
    const params = new URLSearchParams(queryString);

    const { DEPART_DATA, GLOBAL } = this.props;
    const {
      COUNTRY_DATA,
      START_DATE,
      END_DATE,
      MEAL,
      STARS,
      ADULT,
      CHILD,
      REGIONS,
      SUBREGION,
      SERVICE,
      HOTELS,
      PRICE_FROM,
      PRICE_TO,
      MIN_NIGTHS,
      MAX_NIGTHS,
      TOUROPERATORS,
      TOUR_CURRENCY,
    } = GLOBAL;

    let REQUEST_KEYS_MAP = {
      pageSize: 'onpage',
      s_departFrom: 'datefrom',
      s_departTo: 'dateto',
      nightsfrom: 'nightsfrom',
      nightsto: 'nightsto',
      s_nightsMin: 'nightsfrom',
      s_nightsMax: 'nightsto',
      s_adults: 'adults',
      s_kids: 'child',
      s_kids_ages: 'ages',
      service: 'services',
    };

    if (params.get('departure')) {
      /**
       * ПАРАМЕТРЫ ИЗ URL
       */

      for (const [key, value] of params) {
        if (store.hasOwnProperty(key)) {
          if (Array.isArray(store[key])) {
            let valuesList = value.split(',').filter((val) => !!val) || [];
            store[key] = valuesList;
          } else {
            store[key] = value;
          }
          console.log('params:', key, value);
        } else {
          if (REQUEST_KEYS_MAP[key]) {
            let field = REQUEST_KEYS_MAP[key];
            console.log('params:', field, key, value);
            if (Array.isArray(store[field])) {
              let valuesList = value.split(',').filter((val) => !!val) || [];
              // console.warn('key:', field, key, valuesList);
              store[field] = valuesList;
            } else {
              store[field] = value;
            }
          }
        }
      }
    } else {
      /**
       * ПАРАМЕТРЫ ИЗ АДМИНКИ
       */
      if (DEPART_DATA) {
        store.departure = +this.props.DEPART_DATA.id;
      }

      if (COUNTRY_DATA && COUNTRY_DATA.id) {
        store.country = COUNTRY_DATA.id;
      }
      if (START_DATE && END_DATE) {
        const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

        store.datefrom = dateRegex.test(START_DATE)
          ? moment(START_DATE, 'DD/MM/YYYY').format('DD.MM.YYYY')
          : START_DATE;
        store.dateto = dateRegex.test(END_DATE)
          ? moment(END_DATE, 'DD/MM/YYYY').format('DD.MM.YYYY')
          : END_DATE;
      }

      if (MEAL && Array.isArray(MEAL)) {
        store.meal = MEAL[0];
      }

      if (STARS) {
        store.stars = STARS;
      }

      if (ADULT) {
        store.adults = ADULT;
        if (CHILD) {
          store.child = CHILD;
        }
      }

      if (REGIONS && Array.isArray(REGIONS)) {
        store.regions = REGIONS.map((region) => +region.id);
      }

      if (SUBREGION) {
        store.subregions = [parseInt(SUBREGION)];
      }

      if (HOTELS && Array.isArray(HOTELS)) {
        store.hotels = HOTELS;
      }

      if (SERVICE) {
        store.services = [parseInt(SERVICE)];
      }

      if (PRICE_FROM) {
        store.pricefrom = [parseInt(PRICE_FROM)];
      }

      if (PRICE_TO) {
        store.priceto = [parseInt(PRICE_TO)];
      }

      if (MIN_NIGTHS) {
        store.nightsfrom = parseInt(MIN_NIGTHS);
      }

      if (TOUROPERATORS && Array.isArray(TOUROPERATORS)) {
        store.operators = TOUROPERATORS.map((operator) => operator.id);
      }

      if (MAX_NIGTHS) {
        store.nightsto = parseInt(MAX_NIGTHS);
      }

      if (TOUR_CURRENCY) {
        store.currency = TOUR_CURRENCY;
      }
    }

    this.handleAutosearch(true);
    console.log('getPrepareParams:', store);
    return store;
  }

  setToursResults(hotels) {
    this.handleSortPrice(hotels);
  }

  fetcher(requests, method) {
    const tourRequests = requests.map((request) => {
      const { TOUROPERATOR } = this.props.GLOBAL;
      if (TOUROPERATOR && !request.operators) {
        request.operators = [TOUROPERATOR.id];
      }
      if (!request.cityFromId) {
        request.cityFromId = this.state.request.departure;
      }
      // fix price fore request
      request.priceto = this.state.request.priceto;
      return new TourRequest(request);
    });
    console.warn('TOUR_REQUESTS', tourRequests);

    const tourFetcher = new TourFetcher(tourRequests);

    const signal = (data) => {
      console.log('DATA: ', data);
      this.setToursResults(data);
    };

    tourFetcher
      .fetchTourResults(signal)
      .then((results) => {
        console.log('Результаты получены:', results);
        // обновляем компонент списка с турами
        this.setToursResults(results);
      })
      .catch((error) => {
        console.error('Ошибка при получении результатов:', error);
      });
  }

  prepareParams() {
    const isMobile = () =>
      /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const { GLOBAL } = this.props;
    const { TOURS_REQUEST } = GLOBAL;
    let TOURS_REQUEST_API_METHOD = 'search';

    console.log('GLOBAL PARAMS:', GLOBAL);

    if (isMobile()) {
      this.setState({
        is_mobile: isMobile(),
      });
    }

    if (hasQueryStringParameters()) {
      // учитываем параметры url
      // заполняем параметры формы поиска значениями из URL
      console.log('hasQueryStringParameters TRUE');
      this.handleSearch();
    } else if (
      this.props.PAGE === 'tourist' ||
      this.props.PAGE === 'custom' ||
      this.props.PAGE === 'tours'
    ) {
      if (!isLoadForm) {
        if (
          TOURS_REQUEST &&
          TOURS_REQUEST.request &&
          !!TOURS_REQUEST.request.length
        ) {
          console.log('TOUR_REQUEST_SIZE:', TOURS_REQUEST.request.length);
          console.log('TOUR_REQUEST INNER CONTENT: ', TOURS_REQUEST);

          if (TOURS_REQUEST.request.length === 1) {
            // в админке может быть tours_request параметры, и выставлены также параметры для
            // формы поиска по стране с заданными точными настройками, в этом случае приоритет
            // поиска отдавать параметрам точным если задана страна.

            // для одного направления заполняем форму поиска параметрами из админки и производим поиск
            if (
              typeof TOURS_REQUEST.options !== 'undefined' &&
              TOURS_REQUEST.options.type &&
              TOURS_REQUEST.options.type === 'hot'
            ) {
              TOURS_REQUEST_API_METHOD = 'hot';
              this.fetcher(TOURS_REQUEST.request, TOURS_REQUEST_API_METHOD);
            } else {
              this.handleSearch();
              this.handleAutosearch(false);
            }
          } else if (typeof TOURS_REQUEST.options !== 'undefined') {
            TOURS_REQUEST_API_METHOD =
              TOURS_REQUEST.options.type === 'tour'
                ? 'search'
                : TOURS_REQUEST.options.type;
            console.warn(`METHOD ${TOURS_REQUEST_API_METHOD}`);
            this.fetcher(TOURS_REQUEST.request, TOURS_REQUEST_API_METHOD);
          }
        } else {
          this.handleSearch(true);
          this.handleAutosearch(false);
        }
      }
    } else if (this.props.PAGE === 'office' || this.props.PAGE === 'hot') {
      console.log('PAGE', this.props.PAGE);
      if (TOURS_REQUEST && !!TOURS_REQUEST.request.length) {
        console.log('TOUR_REQUEST_SIZE:', TOURS_REQUEST.request.length);
        console.warn(TOURS_REQUEST);

        // выставляем тип поиска search | hot
        if (typeof TOURS_REQUEST.options !== 'undefined') {
          TOURS_REQUEST_API_METHOD =
            TOURS_REQUEST.options.type === 'tour'
              ? 'search'
              : TOURS_REQUEST.options.type;
        }

        if (TOURS_REQUEST_API_METHOD === 'hot') {
          // METHOD: hot
          this.fetchTours();
        } else {
          // METHOD: search
          // пробегаемся по списку request-ов
          TOURS_REQUEST.request.map((request) => {
            const tourRequest = { ...this.state.request };
            let requestExtendKeysList = Object.keys(request);
            requestExtendKeysList.forEach((key) => {
              // фиксим request в каждой итерации
              tourRequest[REQUEST_KEYS_MAP[key]] = request[key];
            });
            this.handleSearchTours(tourRequest);
          });
        }

        // отправляем запрос на турвизор и получаем request ID
        // каждая итерация по request_id собирает список туров result
        // формируем общий список результатов поиска по нескольким request
        // сортируем список (по цене или чередованию стран?)
        // рендерим список на странице
        this.handleAutosearch(false); // переключаем autosearch = false
        // после поиска в модели формы departure и country должны встать исходя из параметров DEPART_DATA и COUNTRY_DATA
      } else {
        this.handleSearch(true);
        this.handleAutosearch(false);
      }
    }
  }

  normalizeRequest(request) {
    console.log('normalize request');
    request.datefrom = request.datefrom.split('/').join('.');
    request.dateto = request.dateto.split('/').join('.');
    console.log('normalize', request);
    return request;
  }

  async handleSearchTours(request) {
    this.normalizeRequest(request);
    let requestQuery = new URLSearchParams(request).toString();
    const res = tourvisorAPI.search(requestQuery);
    this._parseSearchResponse(request, res);
  }

  /**
   * Проверка авторизации пользователя в личном кабинете
   */
  cabinetCheckLogin() {}

  /**
   * Залогиниться в кабинете
   */
  cabinetLogin() {}

  /**
   * Получить лайкнутые туры чтобы пометить их на выгрузке
   */
  cabinetGetLikesTours() {}

  showLoginForm() {}

  hideLoginForm() {}

  touroperatorsExcluded() {
    const { TOUROPERATORS_EXCLUDED } = this.props.GLOBAL;
    if (TOUROPERATORS_EXCLUDED && Array.isArray(TOUROPERATORS_EXCLUDED)) {
      if (TOUROPERATORS_EXCLUDED.length) {
        this.setState({
          touroperatorsExcluded: TOUROPERATORS_EXCLUDED,
        });
      }
    }
  }

  setDiscount() {
    const { DISCOUNT } = this.props.GLOBAL;
    if (DISCOUNT && Array.isArray(DISCOUNT)) {
      if (DISCOUNT.length) {
        this.setState({
          discount: DISCOUNT,
        });
      }
    }
  }

  toggleHotelPopup(e) {
    const { classList, nodeName } = e.target;
    if (
      classList.value === 'hotel-popup hotel-popup__opened' ||
      classList.value === 'hotel-popup__close-btn' ||
      nodeName === 'path'
    ) {
      this.setState({ isHotelPopupOpened: false });
    }
  }

  setHotelData(hotelData, hotelId) {
    this.setState({ hotelData, hotelId });
  }

  getHotelInfo = async (hotelId, hotelPopupTabNumber = 0) => {
    if (hotelId === this.state.hotelId) {
      this.setState({ isHotelPopupOpened: true, hotelPopupTabNumber });
    } else {
      const { data } = await tourvisorAPI.getHotelInfo(hotelId);
      if (data.hotel) {
        this.setHotelData(data.hotel, hotelId);
        this.setState({ isHotelPopupOpened: true, hotelPopupTabNumber });
      }
    }
  };

  restartSearchWithNewRequest() {
    if (this.controllerRef) {
      this.setState({
        stopSearchNotification: true,
        isSearching: false,
      });
      setTimeout(() => {
        this.setState({ stopSearchNotification: false });
      }, 2000);
      this.controllerRef.abort();
      if (this.checkTourRequestTimeoutRef) {
        clearTimeout(this.checkTourRequestTimeoutRef);
      }
      this.setState(
        {
          response: {
            data: {
              status: { progress: 100 },
            },
          },
        },
        () => {
          this.handleSearch();
        }
      );
    }
  }

  setHotelsIdWithReviews() {
    geograftourAPI
      .getHotelsWithReviews(this.state.request.country)
      .then((res) => {
        const hotelsId = res.map((hotel) => hotel.tourvisor_id.toString());
        this.setState({
          hotelsIdWithReviews: hotelsId,
        });
      });
  }

  handleAutosearch(state) {
    this.setState({
      autosearch: state,
    });
  }

  componentDidMount() {
    localStorage.removeItem('officeId');
    this.setHotelsIdWithReviews();
    this.prepareParams();

    this.setState({
      response: {
        data: {
          status: {
            progress: 100,
          },
        },
      },
    });
    this.getCart();
    isLoadForm = true;
    this.touroperatorsExcluded();
    this.setDiscount();
  }

  render() {
    const {
      departure,
      country,
      datefrom,
      dateto,
      nightsfrom,
      nightsto,
      stars,
      adults,
      child,
      ages,
      meal,
      hotels,
      pricefrom,
      priceto,
      currency,
      regions,
      subregions,
      services,
      rating,
      recomend,
      hideregular,
      actypes,
    } = this.state.request;
    const { data } = this.state.response;
    const {
      recomend_hotels,
      showAll,
      carts,
      likes,
      touroperatorsExcluded,
      discount,
      isHotelPopupOpened,
      hotelData,
      hotelId,
      isHotelInfoLoading,
      response,
      is_mobile,
      searchErrorText,
      searchError,
      stopSearchNotification,
      flightTypeChange,
      autosearch,
      hotelPopupTabNumber,
      isSearching,
      hotelsIdWithReviews,
      hasReviews,
    } = this.state;

    const { cart } = this.state;
    const isAuth = cart.user ? true : false;

    const CountrySorted = Object.values(COUNTRY_DIC)
      .map(function (item) {
        return {
          id: item.id,
          value: item.id,
          label: item.name,
          name: item.name,
          code: item.code,
          url: item.url,
          rank: item.rank,
          sort: item.rank.toString() + '_' + item.name,
          category: COUNTRY_RANK_DIC[item.rank],
        };
      })
      .sort(function (a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });

    DATES_LIST.push(datefrom);
    COUNTRY_LIST.push(country);
    return (
      <>
        <HotelInfoView
          isHotelInfoLoading={isHotelInfoLoading}
          isHotelPopupOpened={isHotelPopupOpened}
          toggleHotelPopup={this.toggleHotelPopup}
          hotel={hotelData}
          hotelId={hotelId}
          hotelPopupTabNumber={hotelPopupTabNumber}
        />
        {!this.state.is_mobile ? (
          <div
            className="search-tour-form search-tour-form__tourist-new container"
            style={{ width: 560 }}
          >
            <LinksBar />
            <CartBar cart={cart} likes={likes} isAuth={isAuth} />
            <div className="flex-wrapper">
              <DepartCity
                value={departure}
                onChoose={this.setDepart}
                dictionary={DEPART_CITY_DIC}
              />
              <DestinationCountry
                value={country}
                depart={departure}
                currency={currency}
                onChoose={this.setCountry}
                items={CountrySorted}
                dictionary={COUNTRY_DIC}
              />
              <Dates
                datefrom={datefrom}
                dateto={dateto}
                departure={this.state.request.departure}
                country={country}
                currency={currency}
                onChoose={this.setDates}
                hideregular={hideregular}
                onChangeRegular={this.setRaces}
                is_mobile={is_mobile}
              />
              <Nights
                value={[nightsfrom, nightsto]}
                onChoose={this.setNights}
              />
            </div>
            <div className="flex-wrapper">
              <Peoples
                adults={adults}
                kids={child}
                ages={ages}
                onChoose={this.setPeoples}
              />
              <Regions
                isOpen={false}
                value={regions}
                subvalue={subregions}
                country={country}
                onChoose={this.setRegions}
                onSubChoose={this.setSubRegions}
              />
              <Stars value={stars} onChoose={this.setStars} />
              <Meals value={meal} onChoose={this.setMeal} />
            </div>
            <div className="flex-wrapper">
              <Hotels
                isOpen={false}
                value={hotels}
                country={country}
                stars={stars}
                regions={regions}
                subregions={subregions}
                recomend={recomend}
                onRecomend={this.handleRecomend}
                rating={rating}
                onChoose={this.setHotels}
                onReset={this.resetHotels}
                onSetRating={this.setRating}
                onSetRecommend={this.setRecomendHotels}
                autoSearch={autosearch}
                hasReviews={hasReviews}
                onSetWithReviews={this.handleHasReviews}
                hotelsIdWithReviews={hotelsIdWithReviews}
                setHotelsIdWithReviews={this.setHotelsIdWithReviews}
              />
              <Price
                pricefrom={pricefrom}
                priceto={priceto}
                currency={currency}
                onChoose={this.setPrice}
              />
              <Services
                valueServices={services}
                valueActypes={actypes}
                onChooseServices={this.setServices}
                onChooseActypes={this.setActypes}
              />
              <Races value={hideregular} onChoose={this.setRaces} />
            </div>
            <div className="flex-wrapper">
              <SearchTourButton
                onSearch={
                  isSearching
                    ? this.restartSearchWithNewRequest
                    : this.handleSearch
                }
              />
            </div>
          </div>
        ) : (
          <div className="search-tour-form search-tour-form__tourist-new search-tour-form__tourist-new--mobile container">
            <LinksBar />
            <CartBar cart={cart} likes={likes} isAuth={isAuth} />
            <div className="flex-wrapper">
              <DepartCity
                value={departure}
                onChoose={this.setDepart}
                dictionary={DEPART_CITY_DIC}
              />
              <DestinationCountry
                value={country}
                depart={departure}
                currency={currency}
                onChoose={this.setCountry}
                items={CountrySorted}
                dictionary={COUNTRY_DIC}
              />
            </div>
            <div className="flex-wrapper">
              <Dates
                datefrom={this.state.request.datefrom}
                dateto={this.state.request.dateto}
                departure={this.state.request.departure}
                country={country}
                currency={currency}
                hideregular={hideregular}
                onChangeRegular={this.setRaces}
                onChoose={this.setDates}
                is_mobile={is_mobile}
              />
              <Nights
                value={[nightsfrom, nightsto]}
                onChoose={this.setNights}
              />
            </div>
            <div className="flex-wrapper">
              <Peoples
                adults={adults}
                kids={child}
                ages={ages}
                onChoose={this.setPeoples}
              />
              <Regions
                isOpen={false}
                value={regions}
                subvalue={subregions}
                onSubChoose={this.setSubRegions}
                country={country}
                onChoose={this.setRegions}
              />
            </div>
            <div className="flex-wrapper">
              <Stars value={stars} onChoose={this.setStars} />
              <Meals value={meal} onChoose={this.setMeal} />
            </div>
            <div className="flex-wrapper">
              <Hotels
                isOpen={false}
                value={hotels}
                country={country}
                stars={stars}
                regions={regions}
                subregions={subregions}
                recomend={recomend}
                onRecomend={this.handleRecomend}
                rating={rating}
                onChoose={this.setHotels}
                onReset={this.resetHotels}
                onSetRating={this.setRating}
                onSetRecommend={this.setRecomendHotels}
                autoSearch={autosearch}
                hasReviews={hasReviews}
                onSetWithReviews={this.handleHasReviews}
                hotelsIdWithReviews={hotelsIdWithReviews}
                setHotelsIdWithReviews={this.setHotelsIdWithReviews}
              />
              <Services
                valueServices={services}
                valueActypes={actypes}
                onChooseServices={this.setServices}
                onChooseActypes={this.setActypes}
              />
            </div>
            <div className="flex-wrapper">
              <Price
                pricefrom={pricefrom}
                priceto={priceto}
                currency={currency}
                onChoose={this.setPrice}
              />
              <Races value={hideregular} onChoose={this.setRaces} />
            </div>
            <div className="flex-wrapper">
              <SearchTourButton
                onSearch={
                  isSearching
                    ? this.restartSearchWithNewRequest
                    : this.handleSearch
                }
              />
            </div>
          </div>
        )}

        {data && data.status && (
          <div
            className="result container"
            style={{ display: 'block', maxWidth: 560, fontSize: 12 }}
          >
            {(data.status?.progress !== 100) & !response.expire ? (
              <div style={{ padding: '20px' }}>
                <ProgressBar
                  bgColor={'#DE4596'}
                  completed={data.status.progress}
                />
              </div>
            ) : null}
            {!this.state.results.length && !this.state.items.length && (
              <div className="search__info">
                <div className="search__point">
                  <FaHotel className="search__point-icon" />
                  <div className="search__point-text">
                    Найдено отелей:
                    {data.status.hotelsfound ? (
                      <>
                        <b>{data.status.hotelsfound}</b>
                        {isSearching ? (
                          <div className="loading-rotator"></div>
                        ) : null}
                      </>
                    ) : (
                      <>
                        {isSearching ? (
                          <div className="loading-rotator"></div>
                        ) : (
                          <b>0</b>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div className="search__point">
                  <FaStar className="search__point-icon" />
                  <div className="search__point-text">
                    Найдено туров:
                    {data.status.toursfound ? (
                      <>
                        <b>{data.status.toursfound}</b>
                        {isSearching ? (
                          <div className="loading-rotator"></div>
                        ) : null}
                      </>
                    ) : (
                      <>
                        {isSearching ? (
                          <div className="loading-rotator"></div>
                        ) : (
                          <b>0</b>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
            {data.status.toursfound == 0 &&
            this.state.wasSearching &&
            data.status.progress == 100 ? (
              <SearchNotification
                cssClass="search__message_no-tours"
                message={'Туры не найдены, измените критерии поиска'}
              >
                <AiOutlineInfoCircle />
              </SearchNotification>
            ) : null}
            <SearchNotification
              cssClass={!flightTypeChange ? 'search__message_hidden' : ''}
              message={
                'Чартерные рейсы не найдены. Поиск запущен по всем типам рейсов.'
              }
            >
              <PiAirplaneTakeoffLight />
            </SearchNotification>
            <SearchNotification
              cssClass={!searchError ? 'search__message_hidden' : ''}
              message={searchErrorText}
            >
              <AiOutlineApi />
            </SearchNotification>
            <SearchNotification
              cssClass={!stopSearchNotification ? 'search__message_hidden' : ''}
              message={'Поиск по новым параметрам'}
            >
              <MdOutlineYoutubeSearchedFor />
            </SearchNotification>
          </div>
        )}
        {!!this.state.items.length && (
          <div className="container tours tourist-tours">
            <div className="search__info">
              <div className="search__point">
                <FaStar className="search__point-icon" />
                <p className="search__point-text">
                  Найдено туров: <b>{this.state.items.length}</b>
                </p>
              </div>
            </div>

            {this.state.items.map((tour, idx) => {
              return this.state.is_mobile ? (
                <OneHotTourMobileView
                  tour={tour}
                  discount={discount}
                  idx={idx}
                  getHotelInfo={this.getHotelInfo}
                />
              ) : (
                <OneHotTourView
                  tour={tour}
                  discount={discount}
                  idx={idx}
                  getHotelInfo={this.getHotelInfo}
                />
              );
            })}
          </div>
        )}
        {!!this.state.results.length && (
          <div className="container tours tourist-tours">
            {!!this.state.results.length && (
              <div style={{ marginRight: '15px' }}>
                <FaHotel
                  style={{
                    color: '#fc3',
                    paddingRight: '10px',
                    verticalAlign: 'top',
                    fontSize: '24px',
                    textShadow: '0px 1px 0px rgba(0, 0, 0, 0.4)',
                  }}
                />
                Найдено отелей: <b>{this.state.results.length}</b>
                {isSearching ? <div className="loading-rotator"></div> : null}
              </div>
            )}
            {!!this.state.results.length &&
              this.state.results.map((hotel, idx) => (
                <>
                  {/* {!idx && this.state.fact && idx < HOTELS_LIMIT && (
                    <FactBanner text={this.state.fact} />
                  )} */}
                  {/* {!!this.needBanner(idx) && idx < HOTELS_LIMIT && <Banner />} */}
                  {!!this.needFeature(idx) && idx < HOTELS_LIMIT && (
                    <FeatureBanner key={`feat-${hotel.hotelcode + idx}`} />
                  )}
                  {!!this.needInfo(idx) && idx < HOTELS_LIMIT && (
                    <InfoBanner key={`info-${hotel.hotelcode + idx}`} />
                  )}
                  {!showAll && idx > HOTELS_LIMIT ? null : (
                    <OneTouristHotel
                      key={`hotel-${hotel.hotelcode}`}
                      hotel={hotel}
                      departure={
                        this.state?.requestedDeparture ||
                        this.state.request.departure
                      }
                      request_model={this.state.request}
                      recomend_hotels={recomend_hotels}
                      touroperators_excluded={touroperatorsExcluded}
                      discount={discount}
                      likes={likes}
                      isAuth={isAuth}
                      onCart={this.onCartUpdate}
                      onContinue={this.handleContinue}
                      getHotelInfo={this.getHotelInfo}
                      hotelsIdWithReviews={hotelsIdWithReviews}
                    />
                  )}
                </>
              ))}
          </div>
        )}
        {!this.state.startSearch ? (
          <div ref={this.toursRef} className="container tours tourist-tours">
            {data?.result?.hotel.map((hotel, idx) => (
              <div key={hotel.hotelcode}>
                {/* {!idx && <FactBanner text={this.state.fact} />}
                  {!!this.needBanner(idx) && idx < HOTELS_LIMIT && <Banner />} */}
                {!!this.needFeature(idx) && idx < HOTELS_LIMIT && (
                  <FeatureBanner key={`feat-${hotel.hotelcode + idx}`} />
                )}
                {!!this.needInfo(idx) && idx < HOTELS_LIMIT && (
                  <InfoBanner key={`info-${hotel.hotelcode + idx}`} />
                )}
                {!showAll && idx > HOTELS_LIMIT ? null : (
                  <OneTouristHotel
                    key={hotel.hotelcode}
                    hotel={hotel}
                    departure={
                      this.state?.requestedDeparture ||
                      this.state.request.departure
                    }
                    request_model={this.state.request}
                    recomend_hotels={recomend_hotels}
                    touroperators_excluded={touroperatorsExcluded}
                    discount={discount}
                    likes={likes}
                    carts={carts}
                    isAuth={isAuth}
                    onCart={this.onCartUpdate}
                    onContinue={this.handleContinue}
                    getHotelInfo={this.getHotelInfo}
                    hotelsIdWithReviews={hotelsIdWithReviews}
                  />
                )}
              </div>
            ))}
            {/** Кнопка показать еще если количество туров больше чем выставленный лимит */}
            <div style={{ width: '100%', textAlign: 'center' }}>
              {data &&
              data.result &&
              data.result.hotel &&
              data.result.hotel.length > HOTELS_LIMIT &&
              !showAll ? (
                <button
                  className="btn__search-tour-more"
                  style={{ marginRight: '1em', background: '#3e93d8' }}
                  onClick={this.handleShowHotelsAll}
                >
                  показать еще
                </button>
              ) : (
                <>
                  {/* {(this.state.request_id &&
                    this.state.response.data.status &&
                    this.state.response.data.status.state != 'searching') ||
                  (this.state.response.data.status.requestid &&
                    this.state.response.data.status &&
                    this.state.response.data.status.state != 'searching') ? (
                    <SearchTourMoreButton onContinue={this.handleContinue} />
                  ) : null} */}
                </>
              )}
            </div>
          </div>
        ) : null}
      </>
    );
  }
}

export default SearchTouristForm;
